import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCommunity } from '../../../actions/userActions';
import ZoneAdminRootView from '../../../containers/Zones/Admin/ZoneAdminRoot';
import localStorage from '../../../utils/hooks/useLocalStorage';

export const ZoneAdminRoot = ({match,history,routes}) => {
    const dispatch = useDispatch()
    const {communityInfo} = useSelector(state=>state.userInfo)
    useEffect(() => {
      dispatch(getCommunity(match.params.zoneId));
    
      return () => {
        
      };
    }, [match.params.zoneId]);
    useEffect(() => {
     if(communityInfo.adminUserId && communityInfo.adminUserId._id!==localStorage().getItem('idProfile')){
       // history.push("/")
     }
    
      return () => {
       
      };
    }, [communityInfo]);
    
  return <ZoneAdminRootView zone={communityInfo} routes={routes}/>
};
